import React from 'react'
import { Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const GenericSimpleRenderItems = ({ data = {}, labels = [] }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Row className="d-block mt-2 mb-2">
      <Col>
        { labels.map(renderLeyends) }
      </Col>
    </Row>
  )
}

export default GenericSimpleRenderItems;
